/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CoverageImagePost200Response,
  CoverageImagePostRequest,
  NewSourceIdentifier,
  SourceIdentifier,
  UpdateSourceIdentifier,
} from '../models';
import {
    CoverageImagePost200ResponseFromJSON,
    CoverageImagePost200ResponseToJSON,
    CoverageImagePostRequestFromJSON,
    CoverageImagePostRequestToJSON,
    NewSourceIdentifierFromJSON,
    NewSourceIdentifierToJSON,
    SourceIdentifierFromJSON,
    SourceIdentifierToJSON,
    UpdateSourceIdentifierFromJSON,
    UpdateSourceIdentifierToJSON,
} from '../models';

export interface CoverageImagePostOperationRequest {
    coverageImagePostRequest: CoverageImagePostRequest;
}

export interface SourceIdentifiersGetRequest {
    covEnabled?: boolean;
}

export interface SourceIdentifiersIdDeleteRequest {
    id: string;
}

export interface SourceIdentifiersIdGetRequest {
    id: string;
}

export interface SourceIdentifiersIdPutRequest {
    id: string;
    updateSourceIdentifier: UpdateSourceIdentifier;
}

export interface SourceIdentifiersPostRequest {
    newSourceIdentifier: NewSourceIdentifier;
}

/**
 * 
 */
export class CoverageApi extends runtime.BaseAPI {

    /**
     * Fetch coverage data for a specific source identifier and time range.
     * Fetch coverage data
     */
    async coverageImagePostRaw(requestParameters: CoverageImagePostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoverageImagePost200Response>> {
        if (requestParameters.coverageImagePostRequest === null || requestParameters.coverageImagePostRequest === undefined) {
            throw new runtime.RequiredError('coverageImagePostRequest','Required parameter requestParameters.coverageImagePostRequest was null or undefined when calling coverageImagePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/coverage-image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CoverageImagePostRequestToJSON(requestParameters.coverageImagePostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoverageImagePost200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch coverage data for a specific source identifier and time range.
     * Fetch coverage data
     */
    async coverageImagePost(requestParameters: CoverageImagePostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoverageImagePost200Response> {
        const response = await this.coverageImagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all source identifiers from the database. Optionally filter by `cov_enabled`.
     * List all source identifiers
     */
    async sourceIdentifiersGetRaw(requestParameters: SourceIdentifiersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SourceIdentifier>>> {
        const queryParameters: any = {};

        if (requestParameters.covEnabled !== undefined) {
            queryParameters['cov_enabled'] = requestParameters.covEnabled;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/source-identifiers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SourceIdentifierFromJSON));
    }

    /**
     * Retrieves all source identifiers from the database. Optionally filter by `cov_enabled`.
     * List all source identifiers
     */
    async sourceIdentifiersGet(requestParameters: SourceIdentifiersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SourceIdentifier>> {
        const response = await this.sourceIdentifiersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a source identifier and cascades deletions in related tables.
     * Delete a source identifier
     */
    async sourceIdentifiersIdDeleteRaw(requestParameters: SourceIdentifiersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sourceIdentifiersIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/source-identifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a source identifier and cascades deletions in related tables.
     * Delete a source identifier
     */
    async sourceIdentifiersIdDelete(requestParameters: SourceIdentifiersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sourceIdentifiersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve details of a specific source identifier by ID.
     * Get details of a source identifier
     */
    async sourceIdentifiersIdGetRaw(requestParameters: SourceIdentifiersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SourceIdentifier>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sourceIdentifiersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/source-identifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SourceIdentifierFromJSON(jsonValue));
    }

    /**
     * Retrieve details of a specific source identifier by ID.
     * Get details of a source identifier
     */
    async sourceIdentifiersIdGet(requestParameters: SourceIdentifiersIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SourceIdentifier> {
        const response = await this.sourceIdentifiersIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the position and enable a source identifier by ID.
     * Update a source identifier
     */
    async sourceIdentifiersIdPutRaw(requestParameters: SourceIdentifiersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sourceIdentifiersIdPut.');
        }

        if (requestParameters.updateSourceIdentifier === null || requestParameters.updateSourceIdentifier === undefined) {
            throw new runtime.RequiredError('updateSourceIdentifier','Required parameter requestParameters.updateSourceIdentifier was null or undefined when calling sourceIdentifiersIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/source-identifiers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSourceIdentifierToJSON(requestParameters.updateSourceIdentifier),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the position and enable a source identifier by ID.
     * Update a source identifier
     */
    async sourceIdentifiersIdPut(requestParameters: SourceIdentifiersIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sourceIdentifiersIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Add AIS data from a new station/source identifier.
     * Add a new source identifier
     */
    async sourceIdentifiersPostRaw(requestParameters: SourceIdentifiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.newSourceIdentifier === null || requestParameters.newSourceIdentifier === undefined) {
            throw new runtime.RequiredError('newSourceIdentifier','Required parameter requestParameters.newSourceIdentifier was null or undefined when calling sourceIdentifiersPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/source-identifiers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewSourceIdentifierToJSON(requestParameters.newSourceIdentifier),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add AIS data from a new station/source identifier.
     * Add a new source identifier
     */
    async sourceIdentifiersPost(requestParameters: SourceIdentifiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sourceIdentifiersPostRaw(requestParameters, initOverrides);
    }

}
